import React, { useState, useEffect, useContext, useCallback, useRef } from "react";
import { Button, Col, Row, Typography, Form, Input, InputNumber, Space, Radio, Checkbox, Modal, Collapse } from "antd";
import { Container } from "reactstrap";
import { CloseOutlined, ArrowLeftOutlined, EnvironmentFilled, ClockCircleFilled } from "@ant-design/icons";
import { PublicContext } from "../PublicContext";
import { useNavigate } from "react-router-dom";
import "./Cart.css";
import "../../styles/custom.css";
import OrderDateTimeSelector from "./OrderDateTimeSelector";
import LocationOrderType from "../LocationOrderType";
import dayjs from 'dayjs';
import {
    LoadScript,
    StandaloneSearchBox,
    Polygon
} from "@react-google-maps/api";
import TipsModal from "./TipsModal";

const libraries = ["places", "geometry"];
export default function Checkout() {
    const navigate = useNavigate();
    //const [cart, setCart] = useState([]);
    const {
        setSpinning,
        cart,
        cartNum,
        products,
        stores,
        storeHours,
        orderScheduleTime,
        orderScheduleDate,
        deliveryOrPickUp,
        setDeliveryOrPickUp,
        setCart,
        setCartNum,
        menuUrl,
        setOrderScheduleTime,
        setOrderScheduleDate,
        openNotification,
        changeOrderType,
        CalculateDelivery,
        addressGeocode,
        deliverable,
        setDeliverable,
        selectedStore
    } = useContext(PublicContext);
    const [totals, setTotals] = useState({
        subtotal: 0,
        tax: 0,
        numItems: 0,
        delivery: 0,
        tip: 0,
        total: 0,
    });
    const [isFormValid, setIsFormValid] = useState(false);
    const [submitDisabled, setSubmitDisabled] = useState(false);
    //const [isCartReady, setIsCartReady] = useState(false);
    const [orderType, setOrderType] = useState("delivery");
    const [hasDeliveryAddress, setHasDeliveryAddress] = useState(false);
    const { Title } = Typography;
    const [form] = Form.useForm();
    let streetAddress = "";
    let cityProvinceZip = "";
    var mapDeliveryZones = require("../../data/DeliveryZone.json");
    var storeDeliveryAreaCoords = [];
    var storeLatLng = [];
    const [modalVisible, setModalVisible] = useState(false);
    const [deliverySearchBox, setDeliverySearchBox] = useState(null);
    const [deliveryAddress, setDeliveryAddress] = useState("");
    const [enteredFullAddress, setenteredFullAddress] = useState(false);
    const [deliveryAddressModalVisible, setDeliveryAddressModalVisible] = useState(false);
    const [extendedDeliveryModalVisible, setExtendedDeliveryModalVisible] = useState(false);
    const [tipsModalVisible, setTipsModalVisible] = useState(false);

    const [deliverableStore, setDeliverableStore] = useState(null);
    //const [deliverable, setDeliverable] = useState(false);
    const [tips, setTips] = useState(0);
    const [tipsMode, setTipsMode] = useState("e");

    const [isExpanded, setIsExpanded] = useState(false);

    const extraDeliveryFee = useRef(0);
    var isOptedIn = false;
    //var selectedStore.current = {};
    //const [isOptedIn, setIsOptedIn] = useState(false);

    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };

    const handleKeyPress = (e) => {
        const charCode = e.charCode || e.keyCode;
        // Only allow standard ASCII (char codes between 0 and 127)
        if (charCode > 127) {
            e.preventDefault();
        }
    };

    if (!sessionStorage.getItem("selectedStore")) {
        navigate(`/locationsmap`);
    }
    else {
        selectedStore.current = JSON.parse(sessionStorage.getItem("selectedStore"));
    }

    if (deliveryOrPickUp === "delivery") {
        //console.log("is delivery");
        //let addressObject = JSON.parse(sessionStorage.getItem("selectedAddress"));
        //if (addressObject !== null) {
        //    setHasDeliveryAddress(true);
        //    if (Array.isArray(addressObject)) {
        //        addressObject = addressObject[0];
        //        streetAddress = `${addressObject.address_components[0].long_name} ${addressObject.address_components[1].short_name}`;
        //        cityProvinceZip = `${addressObject.address_components[2].long_name} ${addressObject.address_components[5].short_name} ${addressObject.address_components[7].long_name}`;
        //    } else {
        //        // Parse the string address
        //        const addressParts = addressObject.split(', ');
        //        streetAddress = addressParts[0];
        //        cityProvinceZip = addressParts.slice(1).join(', ');
        //    }
        //}
        //else {
        //    setHasDeliveryAddress(false);
        //}
        // Set streetAddress and cityProvinceZip from the address object
        //const addressObject = JSON.parse(sessionStorage.getItem("selectedAddress"))[0];
        //console.log(addressObject);
        //streetAddress = `${addressObject.address_components[0].long_name} ${addressObject.address_components[1].short_name}`;
        //cityProvinceZip = `${addressObject.address_components[2].long_name} ${addressObject.address_components[5].short_name} ${addressObject.address_components[7].long_name}`;
    }
    else {
        //console.log("is pickup");
        // Set streetAddress and cityProvinceZip from storeAddress
        if (sessionStorage.getItem("selectedStore")) {
            //console.log("stores");
            //console.log(stores);
            //console.log(JSON.parse(sessionStorage.getItem("selectedStore")));
            //console.log(JSON.parse(sessionStorage.getItem("selectedStore")).storeId);
            //console.log(stores.find(store => store.storeId == JSON.parse(sessionStorage.getItem("selectedStore")).storeId));
            const storeAddress = stores.find(store => store.storeId == JSON.parse(sessionStorage.getItem("selectedStore")).storeId).storeAddress;
            const storeAddressParts = storeAddress.split('\r\n');
            streetAddress = storeAddressParts[0];
            cityProvinceZip = storeAddressParts[1];
        }
        else {
            navigate(`/locationsmap`);
        }
    }

    for (let i = 0; i < stores.length; i++) {
        processdeliveryArea(stores[i].storeId);
        // let dz = processdeliveryArea(i);
        // deliveryArea.push(dz);
    }

    let selectedStoreJSON = JSON.parse(sessionStorage.getItem("selectedStore"));
    let store = stores.find(s => s.storeCode === selectedStoreJSON.storeCode);
    let isOnlinePayment = store.onlinePayment;
    //let isOnlinePayment = false;
    //let isInPersonPayment = store.inPersonPayment;
    //let isInPersonPayment = true;
    let isInPersonPayment = false;

    const [paymentMethod, setPaymentMethod] = useState(isOnlinePayment ? "online" : "inPerson");
    const [standardModeAvailable, setStandardModeAvailable] = useState(null);
    const [selectedOrderMode, setSelectedOrderMode] = useState("a");

    useEffect(() => {
        //fetchCart();
        //console.log("checkout useEffect");
        //selectedStore.current = JSON.parse(sessionStorage.getItem("selectedStore")) || {};

        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

        if (!cart) {
            navigate(`/menu?` + menuUrl);
        }
    }, []);

    useEffect(() => {
        const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        const currentTime = dayjs();
        const currentDay = dayjs().day();
        const forthfiveMinutesLater = currentTime.add(45, 'minute');
        const thirtyMinutesLater = currentTime.add(30, 'minute');
        const currentDayStoreHours = storeHours.filter(sh => sh.storeCode === selectedStoreJSON.storeCode && sh.day === daysOfWeek[currentDay] && sh.classification.toLowerCase() === deliveryOrPickUp.toLowerCase())[0];
        if (currentDayStoreHours) {
            const startTime = dayjs(currentDayStoreHours.startTime).format("HH:mm");
            const endTime = dayjs(currentDayStoreHours.endTime).format("HH:mm");

            let isAvailable = false;

            // Get CloseDates from selectedStore, assuming it's stored as JSON
            const selectedStore = JSON.parse(sessionStorage.getItem('selectedStore'));
            let store = stores.find(store => store.storeCode === selectedStore.storeCode);
            let closeDates = [];
            if (store && store.closeDates) {
                closeDates = JSON.parse(store.closeDates);
            }

            // Check if the date is in the CloseDates
            const isClosed = closeDates.some(closeDate => dayjs(closeDate).isSame(dayjs(), 'day'));

            if (isClosed) {
                setStandardModeAvailable(false);
                setSelectedOrderMode("b");
            }
            else {
                if (deliveryOrPickUp === "delivery") {
                    isAvailable = forthfiveMinutesLater.isAfter(dayjs(startTime, "HH:mm")) && forthfiveMinutesLater.isBefore(dayjs(endTime, "HH:mm"));
                    setStandardModeAvailable(isAvailable);
                    if (deliverable) {
                        setSpinning(true);
                        CalculateDelivery();
                    }
                } else if (deliveryOrPickUp === "pickup") {
                    isAvailable = thirtyMinutesLater.isAfter(dayjs(startTime, "HH:mm")) && thirtyMinutesLater.isBefore(dayjs(endTime, "HH:mm"));
                    setStandardModeAvailable(isAvailable);
                }
                if (!isAvailable && selectedOrderMode === "a") {
                    setSelectedOrderMode("b");
                }
            }
        }
        else {
            console.log("checkout not available");
        }

    }, [deliveryOrPickUp]);

    // Function to open the modal
    const openModal = (identifier) => {
        if (identifier === 1) {
            setDeliveryAddressModalVisible(true);
        }
        else if (identifier === 2) {
            setExtendedDeliveryModalVisible(true);
        }
        else if (identifier === 3) {
            setTipsModalVisible(true);
        }
    };

    // Function to close the modal
    const closeModal = () => {
        setDeliveryAddressModalVisible(false);
        setExtendedDeliveryModalVisible(false);
        setTipsModalVisible(false);
    };

    const onTipSubmit = () => {
        submitOrder();
    };

    // Callback function to handle changing to pickup order
    async function handleChangeToPickup() {
        // Logic to handle changing to pickup order
        setDeliveryOrPickUp("pickup");
        await sessionStorage.setItem("deliveryOrPickUp", "pickup");
        closeModal(); // Close the modal after handling the change
    };

    // Callback function to handle choosing a new store location
    const handleChangeStore = () => {
        //console.log("handleChangeStore");
        //console.log(stores);
        // Logic to handle choosing a new store location
        selectedStore.current.storeId = deliverableStore.storeId;
        selectedStore.current.storeCode = deliverableStore.storeCode;
        sessionStorage.setItem("selectedStore", JSON.stringify({ storeId: deliverableStore.storeId, storeCode: deliverableStore.storeCode }));
        //console.log(stores);
        closeModal(); // Close the modal after handling the change
    };

    const handleBacktoMenu = () => {
        closeModal();
        navigate(`/menu?` + menuUrl);
    };

    function processdeliveryArea(id) {
        //console.log("processdeliveryArea " + id);
        let store = stores.find((store) => store.storeId === id);
        if (!store) {
            return null;
        }
        let storedeliveryArea = store;
        //console.log( "delivery zones for:" + id )
        //console.log(storedeliveryArea)
        // console.log(storedeliveryArea)
        if (!storedeliveryArea.deliveryZones) {
            return null;
        }
        let polygons = JSON.parse(storedeliveryArea.deliveryZones);

        polygons.forEach((polygon) => {
            // console.log(polygon);
            let mypaths = polygon.coordinates.map((point) => {
                return { lat: point[1], lng: point[0] };
            });
            //console.log("path")
            // console.log(mypaths)
            //console.log("processdeliveryArea " + polygon.name);
            storeDeliveryAreaCoords.push({
                coordinates: mypaths,
                storeId: polygon.storeID,
                desc: polygon.name,
                extra: polygon.extra || 0
            });
            // console.log(storeDeliveryAreaCoords);

            storeLatLng.push({
                lat: storedeliveryArea.lat,
                lng: storedeliveryArea.lng,
            });
        });
    }

    const handleCheckboxChange = (e) => {
        console.log(e.target.checked);
        isOptedIn = e.target.checked;
        //setIsOptedIn(e.target.checked);
    };

    const handlePaymentChange = e => {
        setPaymentMethod(e.target.value);
    };

    const toggleModal = () => {
        setModalVisible(!modalVisible);
    };

    //const handleSetScheduleDateTime = () => {
    //    //setOrderScheduleDate();
    //    setOrderScheduleTime("Select A Time");
    //};

    const validateAscii = (_, value) => {
        if (value && /[^\x00-\x7F]/.test(value)) {
            return Promise.reject(new Error("Please only enter standard alphanumeric characters."));
        }
        return Promise.resolve();
    };


    const handleValuesChange = (changedValues, allValues) => {
        // setFormValues(allValues);
        sessionStorage.setItem("customerInfo", JSON.stringify(allValues));
    };

    const validateForm = () => {
        form
            .validateFields()
            .then(() => {
                const errors = form.getFieldsError();
                //setIsFormValid(form.isFieldsTouched(true) && errors.length === 0);
                //setIsFormValid(true);
                checkInfo();
            })
            .catch((error) => {
                //console.error("Validation error:", error);
                if (error.errorFields.length > 0) {
                    //console.log("error more than 0");
                    if (error.errorFields.length === 1 && error.errorFields[0].name[0] === 'phone') {
                        //console.log("error at phone");
                        if (isOptedIn) {
                            //console.log("is opted in");
                            //setIsFormValid(false);
                        }
                        else {
                            //console.log("is not opted in");
                            //setIsFormValid(true);
                            checkInfo();
                        }
                    }

                    //setIsFormValid(false);
                }
                else {
                    //setIsFormValid(true);
                    checkInfo();
                }
            });
    }

    function checkInfo() {
        if (deliveryOrPickUp === "delivery" && (!enteredFullAddress || !deliverable)) {
            setSpinning(false);
            if (extraDeliveryFee.current > 0 && cart[0].orderSubtotal < 20) {
                openNotification("error", "Sorry, the order needs to be $20.00 or more for delivery in extended delivery zones.");
            }
            else if (!enteredFullAddress) {
                openNotification("error", "Please enter in a valid delivery address.");
            }
            else if (!deliverable) {
                openNotification("error", "Sorry, we are not able to deliver to your address.");
            }
            return;
        }
        else {
            //setSpinning(true);
            try {
                if (selectedOrderMode === "b" &&
                    (
                        !(sessionStorage.getItem("scheduleTime")).includes(":") ||
                        sessionStorage.getItem("scheduleTime") === "null" ||
                        sessionStorage.getItem("scheduleTime") === null ||
                        sessionStorage.getItem("scheduleTime") === '' ||
                        sessionStorage.getItem("scheduleTime") === 'now'
                    )
                ) {
                    setSpinning(false);
                    console.log("Please select a valid scheduled time.");
                    openNotification("error", "Please select a valid scheduled time.");
                }
                else {
                    //Tips
                    openModal(3);

                    //submitOrder();
                }
            }
            catch (error) {
                openNotification("error", "Please select a valid scheduled time.");
                //console.log(error);
            }
        }
    }

    function CustomerInfoForm() {
        const validatePhoneNumber = (_, value) => {
            const phoneNumberRegex = /^\(\d{3}\) \d{3}-\d{4}$/;
            if (isOptedIn) {
                if (!value) {
                    return Promise.reject('Please enter your phone number');

                } else if (!phoneNumberRegex.test(value)) {
                    return Promise.reject('Please enter a valid phone number');
                }
            }
            return Promise.resolve();
        };

        const formatPhoneNumber = (value) => {
            // Remove non-numeric characters
            const numericValue = value.replace(/\D/g, '');

            // Apply phone number format
            let formattedPhoneNumber = '';
            const phoneNumberLength = numericValue.length;

            if (phoneNumberLength > 0) {
                formattedPhoneNumber = '(' + numericValue.slice(0, 3);
            }
            if (phoneNumberLength > 3) {
                formattedPhoneNumber += ') ' + numericValue.slice(3, 6);
            }
            if (phoneNumberLength > 6) {
                formattedPhoneNumber += '-' + numericValue.slice(6, 10);
            }
            return formattedPhoneNumber;
        };

        const handlePhoneInputChange = (e) => {
            const { value } = e.target;
            const formattedValue = formatPhoneNumber(value);
            form.setFieldsValue({ phone: formattedValue });
        };

        const formItemLayout = {
            labelCol: {
                xs: {
                    span: 6,
                },
                sm: {
                    span: 4,
                },
                md: {
                    span: 6,
                },
                lg: {
                    span: 5,
                },
                xl: {
                    span: 4,
                }
            },
            wrapperCol: {
                xs: {
                    span: 18,
                },
                sm: {
                    span: 20,
                },
                md: {
                    span: 18,
                },
                lg: {
                    span: 19,
                },
                xl: {
                    span: 20,
                }
            },
        };

        return (
            <Form
                form={form}
                name="customerInfoForm"
                onFinish={submitOrder}
                onValuesChange={handleValuesChange}
                layout="horizontal"
                variant="filled"
                {...formItemLayout}
            >
                <Form.Item
                    label="First Name"
                    name="firstName"
                    rules={[
                        { required: true, message: "First Name is required" },
                        { validator: validateAscii }
                    ]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="Last Name"
                    name="lastName"
                    rules={[
                        { required: true, message: "Last Name is required" },
                        { validator: validateAscii }
                    ]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="Email"
                    name="email"
                    rules={[
                        { required: true, message: "Email is required" },
                        { type: "email", message: "Valid Email is required" },
                        { validator: validateAscii }
                    ]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="Phone"
                    name="phone"
                    rules={[
                        { required: false, message: "Phone number is required to receive order status update via text messages" },
                        { validator: validatePhoneNumber }
                    ]}
                >
                    <Input
                        onChange={handlePhoneInputChange}
                        maxLength={14} // Limit input length to match the desired format (###) ###-####
                        placeholder="(###) ###-####"
                    />
                </Form.Item>

                {/*{stores.find(s => s.storeCode === selectedStoreJSON.storeCode).sms ?*/}

                {/*comment out*/}
                {/*<Form.Item valuePropName="checked">*/}
                {/*    <Space>*/}
                {/*        <Checkbox onChange={handleCheckboxChange}></Checkbox>*/}
                {/*        <Typography>*/}
                {/*            By checking this box, I agree to provide phone number for order status contact only. Message and data rates may apply.*/}
                {/*        </Typography>*/}
                {/*    </Space>*/}
                {/*</Form.Item>*/}
                {/*comment out*/}

                {/*:*/}
                {/*<Typography>*/}
                {/*    This location does not send SMS order status updates, but maybe contact you about your order through this phone number.*/}
                {/*</Typography>*/}
                {/*}*/}

            </Form>
        );
    };

    async function submitOrder() {
        setSpinning(true);

        const values = await form.validateFields();
        //Perform form submission logic here
        //console.log(values);

        sessionStorage.setItem("customer", JSON.stringify(values));

        var originalSessionSelectedAddress = "";
        //= JSON.parse(sessionStorage.getItem("selectedAddress"))[0].formatted_address;
        var deliveryAddress = "";
        var aptnum = "";
        var securitycode = "";
        if (deliveryOrPickUp === "delivery") {
            if (JSON.parse(sessionStorage.getItem("selectedAddress")) === null) {
                return;
            }

            originalSessionSelectedAddress = (JSON.parse(sessionStorage.getItem("selectedAddress"))[0].formatted_address).trim();

            if (originalSessionSelectedAddress.length === 0) {
                return
            }

            if (sessionStorage.getItem("aptnum") !== null) {
                aptnum = ", Apt #: " + sessionStorage.getItem("aptnum");
            }

            if (sessionStorage.getItem("securitycode") !== null) {
                securitycode = ", Security Code: " + sessionStorage.getItem("securitycode");
            }
        }

        if (JSON.parse(sessionStorage.getItem("selectedAddress")) !== null) {
            deliveryAddress = JSON.parse(sessionStorage.getItem("selectedAddress"))[0].formatted_address + aptnum + securitycode;
        }

        var tips = 0;

        if (sessionStorage.getItem("tips") !== null) {
            tips = sessionStorage.getItem("tips");
        }

        let order = {
            CartId: cart[0].cartId,
            OrderType: sessionStorage.getItem("deliveryOrPickUp"),
            StoreId: JSON.parse(sessionStorage.getItem("selectedStore")).storeId,
            StoreCode: JSON.parse(sessionStorage.getItem("selectedStore"))
                .storeCode,
            Deliveryaddress: deliveryAddress,
            OrderInstructions: sessionStorage.getItem("orderInstructions"),
            FirstName: values.firstName,
            LastName: values.lastName,
            Email: values.email,
            Phone: values.phone,
            IsOptIn: isOptedIn,
            ScheduleTime: (sessionStorage.getItem("scheduleTime") === 'now' || sessionStorage.getItem("scheduleTime") === '') ? dayjs().format('HH:mm') : sessionStorage.getItem("scheduleTime"),
            ScheduleDate: sessionStorage.getItem("scheduleDate"),
            Tips: tips
        }
        //console.log(order);
        //console.log(JSON.stringify(order));
        //console.log("api/Orders/InitPayment?CartId=" + order.CartId + "&OrderType=" + order.OrderType + "&StoreId=" + order.StoreId + "&StoreCode=" + order.StoreCode + "&Deliveryaddress=" + order.Deliveryaddress + "&OrderInstructions=" + order.OrderInstructions + "&FirstName=" + order.FirstName + "&LastName=" + order.LastName + "&Email=" + order.Email + "&Phone=" + order.Phone + "&ScheduleTime=" + order.ScheduleTime + "&ScheduleDate=" + order.ScheduleDate + "&PaymentMethod=" + paymentMethod + "&IsOptIn=" + isOptedIn);

        if (window.gtag) {
            window.gtag('event', 'Checkout', {
                event_category: 'Button',
                event_label: "Checkout",
            });
        }

        await fetch(("api/Orders/InitPayment?CartId=" + order.CartId + "&OrderType=" + order.OrderType + "&StoreId=" + order.StoreId + "&StoreCode=" + order.StoreCode + "&Deliveryaddress=" + order.Deliveryaddress + "&OrderInstructions=" + order.OrderInstructions + "&FirstName=" + order.FirstName + "&LastName=" + order.LastName + "&Email=" + order.Email + "&Phone=" + order.Phone + "&ScheduleTime=" + order.ScheduleTime + "&ScheduleDate=" + order.ScheduleDate + "&PaymentMethod=" + paymentMethod + "&Tips=" + tips + "&IsOptIn=" + isOptedIn), {
            //await fetch("api/Orders/InitPayment", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-type": "application/json",
            },
            //body: JSON.stringify(order),
        })
            .then(async (response) => {
                setSpinning(false);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();

            })
            .then(data => {
                //console.log(data);
                sessionStorage.setItem("paymentuid", data.uid || 'inPerson');
                sessionStorage.setItem("orderId", data.orderId);
                if (paymentMethod === 'online') {
                    navigate(`/payment`);
                }
                else {
                    setCart(null);
                    setCartNum(0);
                    localStorage.removeItem("mandarinCart");
                    localStorage.removeItem("cart");
                    localStorage.setItem("orderId", data.orderId);
                    navigate(`/order?OrderId=${data.orderId}&Email=${order.Email}`);
                }
            })
            .catch((error) => {
                setSpinning(false);
                openNotification("error", "Something went wrong, please try again later.");
                //console.error(error);
            });
    }

    const StoreNotDeliverableModal = ({ store, onCancel, onChangeToPickup, onChangeStore }) => {
        return (
            <>
                {
                    store ?
                        <Modal
                            title="Out of delivery zone"
                            className="deliveryAddressModal"
                            open={deliveryAddressModalVisible}
                            onCancel={onCancel}
                            footer={[
                                //<Button className="btn-secondaryv" key="changeStore" type="primary" block onClick={onChangeStore}>
                                //    Change To {store.storeName}
                                //</Button>,
                                <Button className="btn-primary modal-btns" key="changeToPickup" block onClick={onChangeToPickup}>
                                    Change to Pickup
                                </Button>,
                                <Button className="btn-cancel-outline btn-outline modal-btns" key="cancel" block onClick={onCancel}>
                                    Cancel
                                </Button>
                            ]}
                        >
                            <Typography>
                                Sorry, we are <strong>NOT</strong> able to deliver to your address from the <strong>{stores.find(store => store.storeCode === selectedStore.current.storeCode).storeName}</strong> location you have selected.
                            </Typography>
                            {/*<Typography>*/}
                            {/*    You can either change to a <strong>pickup</strong> order or change to the <strong>{store.storeName}</strong> location.*/}
                            {/*</Typography>*/}
                        </Modal>
                        :
                        <Modal
                            title="Out of delivery zone"
                            className="deliveryAddressModal"
                            open={deliveryAddressModalVisible}
                            onCancel={onCancel}
                            footer={[
                                //<Button className="btn-secondary" key="changeStore" type="primary" onClick={onChangeStore}>
                                //    Change To {store.storeName}
                                //</Button>,
                                <Button className="btn-primary modal-btns" key="changeToPickup" block onClick={onChangeToPickup}>
                                    Change to Pickup
                                </Button>,
                                <Button className="btn-cancel-outline btn-outline modal-btns" key="cancel" block onClick={onCancel}>
                                    Cancel
                                </Button>
                            ]}
                        >
                            <Typography>
                                Sorry, we are <strong>NOT</strong> able to deliver to your address from the <strong>{stores.find(store => store.storeCode === selectedStore.current.storeCode).storeName}</strong> location you have selected.
                            </Typography>
                            {/*<Typography>*/}
                            {/*    You can either change to a <strong>pickup</strong> order or change to the <strong>{store.storeName}</strong> location.*/}
                            {/*</Typography>*/}
                        </Modal>
                }
            </>
        );
    };

    const ExtendedDeliveryLowerThan20Modal = ({ onCancel, onChangeToPickup, onBacktoMenu }) => {
        return (
            <Modal
                title="Order Too Low For Delivery"
                open={extendedDeliveryModalVisible}
                onCancel={onCancel}
                footer={[
                    <Button className="btn-primary" key="changeToPickup" onClick={onChangeToPickup}>
                        Change to Pickup
                    </Button>,
                    <Button className="btn-secondary" key="backtoMenu" type="primary" onClick={onBacktoMenu}>
                        Back to Menu
                    </Button>,
                ]}
            >
                <Typography>
                    The delivery address you have entered is in our extended delivery zone.
                </Typography>
                <Typography>
                    The order needs to be <strong>$20.00 or more</strong> for delivery in extended delivery zones.
                </Typography>
                <Typography>
                    You can either change to a pickup order or add more to cart.
                </Typography>
            </Modal>
        );
    };

    const onDeliverySearchBoxLoad = useCallback((ref) => {
        setDeliverySearchBox(ref);
    }, []);

    const onDeliveryPlacesChanged = useCallback(async () => {
        let enteredLocation = deliverySearchBox.getPlaces();
        let count = 0;

        addressGeocode.current = {
            lat: enteredLocation[0].geometry.location.lat(),
            lng: enteredLocation[0].geometry.location.lng(),
        };

        selectedStore.current = JSON.parse(sessionStorage.getItem("selectedStore"));
        sessionStorage.setItem("selectedAddress", JSON.stringify(enteredLocation));

        setDeliveryAddress(enteredLocation[0].formatted_address);

        if (window.gtag) {
            window.gtag('event', 'FormatAddress', {
                event_category: 'AddressInput',
                event_label: enteredLocation[0].formatted_address,
            });
        }

        if (enteredLocation[0].types[0] === "street_address" || enteredLocation[0].types[0] === "premise" || enteredLocation[0].types[0] === "subpremise") {
            setenteredFullAddress(true);
            var tempDelivertableStoreList = [];
            extraDeliveryFee.current = 0;
            storeDeliveryAreaCoords.forEach((deliveryCoords) => {
                const deliveryzone = new window.google.maps.Polygon({
                    paths: deliveryCoords.coordinates,
                });

                if (
                    window.google.maps.geometry.poly.containsLocation(
                        addressGeocode.current,
                        deliveryzone
                    )
                ) {
                    //console.log(deliveryCoords);
                    if (deliveryCoords.extra > extraDeliveryFee.current) {
                        extraDeliveryFee.current = deliveryCoords.extra;
                        //console.log(extraDeliveryFee.current);
                    }
                    let tempStore = JSON.parse(localStorage.getItem("stores")).find(store => store.storeId === deliveryCoords.storeId);
                    const isExisting = tempDelivertableStoreList.some(
                        (obj) => obj.storeId === tempStore.storeId
                    );
                    if (!isExisting) {
                        count++;
                        tempDelivertableStoreList.push(tempStore);
                    }
                }
            });

            if (count > 0) {
                if (tempDelivertableStoreList.find(store => store.storeCode === selectedStore.current.storeCode)) {
                    //console.log("In selected store's delivery zone");
                    //console.log(extraDeliveryFee.current + " " + cart[0].orderSubtotal);
                    if (extraDeliveryFee.current > 0 && cart[0].orderSubtotal < 20) {
                        //setSubmitDisabled(true);
                        setDeliverable(false);
                        openModal(2);
                    }
                    else {
                        //setSubmitDisabled(false);
                        setSpinning(true);
                        await CalculateDelivery();
                    }
                }
                else {
                    //console.log("Not in selected store's delivery zone");
                    setDeliverable(false);
                    setDeliverableStore(tempDelivertableStoreList[0]);
                    openModal(1);
                }
            }
            else {
                //console.log("Not in delivery zone");
                setDeliverable(false);
            }
        }
        else {
            setenteredFullAddress(false);
        }
    }, [deliverySearchBox]);

    return (
        <Container tag="main">
            <div className="py-5 h-100">
                <Button
                    onClick={() => {
                        if (window.gtag) {
                            window.gtag('event', 'GoBackToMenuFromCheckout', {
                                event_category: 'Button',
                                event_label: 'GoBackToMenuFromCheckout',
                            });
                        }
                        navigate(`/menu?` + menuUrl);
                    }}
                >
                    <ArrowLeftOutlined />
                    Back To Menu
                </Button>
                {/*<LocationOrderType />*/}
                <Row className="justify-content-center align-items-center h-100">
                    <Col md={24} lg={24} xl={24}>
                        <Row>
                            <Col xs={24} md={12}>
                                <div className="p-4 OrderSummaryDiv">
                                    <Title level={4} tag="h3" className="fw-bold mb-3 mt-2 pt-1">
                                        {deliveryOrPickUp === "delivery" ? "Delivery Order" : "Pickup Order"}
                                    </Title>
                                    <div style={{ display: 'flex', flexDirection: 'column', padding: 10 }}>
                                        <Row style={{ display: 'flex', }}>
                                            <Col span={2}>
                                                <EnvironmentFilled style={{ fontSize: 20 }} />
                                            </Col>
                                            <Col span={22}>
                                                {deliveryOrPickUp === "pickup" ?
                                                    <div style={{ marginBottom: 10 }}>
                                                        <Title level={5}>Pickup Address: </Title>
                                                        <Title level={5}>{streetAddress}</Title>
                                                        <div style={{ fontSize: 14 }}>{cityProvinceZip}</div>
                                                    </div>
                                                    :
                                                    <>
                                                        {
                                                            hasDeliveryAddress ?
                                                                <div style={{ marginBottom: 10 }}>
                                                                    <Title level={5}>{streetAddress}</Title>
                                                                    <div style={{ fontSize: 14 }}>{cityProvinceZip}</div>
                                                                </div>
                                                                :
                                                                //googleMapsApiKey = "AIzaSyDMag6mcpti-LqIRnknTGYqIAq5quT_Z7U" - prod
                                                                //googleMapsApiKey = "AIzaSyB8PS9NYRcIupRnc8XzEFI_C3ALTyzJ4FQ" - dev
                                                                <>
                                                                    <LoadScript
                                                                        googleMapsApiKey="AIzaSyDMag6mcpti-LqIRnknTGYqIAq5quT_Z7U"
                                                                        libraries={libraries}
                                                                        language="en"
                                                                        region="us"
                                                                    >
                                                                        <StandaloneSearchBox
                                                                            onLoad={onDeliverySearchBoxLoad}
                                                                            onPlacesChanged={onDeliveryPlacesChanged}
                                                                        >
                                                                            <Input
                                                                                type="text"
                                                                                name="address"
                                                                                placeholder="Enter Your Delivery Address"
                                                                                autoComplete="on"
                                                                                value={deliveryAddress}
                                                                                onChange={e => {
                                                                                    if (window.gtag) {
                                                                                        window.gtag('event', 'AddressInput', {
                                                                                            event_category: 'AddressInput',
                                                                                            event_label: e.target.value,
                                                                                        });
                                                                                    }
                                                                                    setDeliveryAddress(e.target.value);
                                                                                }}
                                                                                style={{ width: "90%" }}
                                                                            ></Input>
                                                                        </StandaloneSearchBox>
                                                                        {!enteredFullAddress && (
                                                                            <div style={{ color: 'red' }}>Need to enter a valid address.</div>
                                                                        )}
                                                                        {enteredFullAddress && !deliverable && !(extraDeliveryFee.current > 0 && cart[0].orderSubtotal < 20) && (
                                                                            <div style={{ color: 'red' }}>Sorry, we cannot deliver to this address from this location.</div>
                                                                        )}
                                                                        {enteredFullAddress && !deliverable && (extraDeliveryFee.current > 0 && cart[0].orderSubtotal < 20) && (
                                                                            <div style={{ color: 'red' }}>Sorry, the order needs to be $20.00 or more for delivery in extended delivery zones.</div>
                                                                        )}
                                                                    </LoadScript>
                                                                    <Space direction="horizontal" style={{ marginTop: "10px" }}>
                                                                        <Space.Compact>
                                                                            <Input placeholder="Apt #"
                                                                                count={{
                                                                                    show: false,
                                                                                    max: 10,
                                                                                    strategy: (txt) => txt.length,
                                                                                    exceedFormatter: (txt, { max }) => txt.slice(0, max),
                                                                                }}
                                                                                onChange={e => {
                                                                                    sessionStorage.setItem("aptnum", e.target.value);
                                                                                }}
                                                                            />
                                                                        </Space.Compact>
                                                                        <Space.Compact>
                                                                            <Input placeholder="Buzzer #"
                                                                                count={{
                                                                                    show: false,
                                                                                    max: 10,
                                                                                    strategy: (txt) => txt.length,
                                                                                    exceedFormatter: (txt, { max }) => txt.slice(0, max),
                                                                                }}
                                                                                onChange={e => {
                                                                                    sessionStorage.setItem("securitycode", e.target.value);
                                                                                }}
                                                                            />
                                                                        </Space.Compact>
                                                                    </Space>
                                                                </>
                                                        }
                                                    </>
                                                }
                                            </Col>

                                            {/*<Button type="primary">Change</Button>*/}
                                        </Row>

                                        <Row style={{ display: 'flex', marginTop: 20 }}>
                                            <Col span={2}>
                                                <ClockCircleFilled style={{ fontSize: 20 }} />
                                            </Col>
                                            <Col span={22}>
                                                {standardModeAvailable != null &&
                                                    <Radio.Group value={selectedOrderMode} onChange={(e) => setSelectedOrderMode(e.target.value)} className="vertical-radio-group">
                                                        {standardModeAvailable ?
                                                            <Radio.Button value="a" onClick={() => {
                                                                setOrderScheduleTime(dayjs().format("HH:mm"));
                                                                sessionStorage.setItem("scheduleTime", dayjs().format("HH:mm"));
                                                                setOrderScheduleDate(dayjs().format("MMM-DD"));
                                                                sessionStorage.setItem("scheduleDate", orderScheduleDate);
                                                                setSelectedOrderMode("a");
                                                            }}>
                                                                <Typography level={5}>
                                                                    {deliveryOrPickUp === "delivery" ? "Standard Delivery " : "Standard Pickup "}
                                                                </Typography>
                                                                <Typography>
                                                                    {deliveryOrPickUp === "delivery" ? <>{store.estimatedDeliveryTime}-{store.estimatedDeliveryTime + 15} Minutes</> : <>{store.estimatedPickupTime}-{store.estimatedPickupTime + 15} Minutes</>}
                                                                </Typography>
                                                            </Radio.Button>
                                                            :
                                                            <Radio.Button value="a" disabled>
                                                                <Typography level={5} style={{ color: "gray" }}>
                                                                    {deliveryOrPickUp === "delivery" ? "Standard Delivery " : "Standard Pickup "}
                                                                </Typography>
                                                                <Typography style={{ color: "gray" }}>
                                                                    Not Available Now
                                                                </Typography>
                                                            </Radio.Button>
                                                        }

                                                        <Radio.Button value="b" onClick={() => {
                                                            toggleModal();
                                                            setSelectedOrderMode("b");
                                                            //handleSetScheduleDateTime();
                                                        }}>
                                                            <Typography level={5}>
                                                                Schedule the {deliveryOrPickUp === "delivery" ? "Delivery " : "Pickup "}
                                                            </Typography>
                                                            <Typography>
                                                                <Space>
                                                                    {orderScheduleDate}
                                                                    {(orderScheduleTime != null && orderScheduleTime.length > 0) ? orderScheduleTime : "Select A Time"}
                                                                </Space>
                                                            </Typography>
                                                        </Radio.Button>
                                                    </Radio.Group>
                                                }
                                            </Col>
                                            {/*<Col>*/}
                                            {/*    <Button className="btn-primary" type="primary" onClick={toggleModal}>Schedule</Button>*/}
                                            {/*</Col>*/}

                                        </Row>
                                    </div>
                                    <OrderDateTimeSelector visible={modalVisible} setVisible={setModalVisible} />
                                </div>

                                {(isOnlinePayment && isInPersonPayment) &&
                                    <div className="p-4">
                                        <Title level={4} tag="h3" className="fw-bold mb-3 mt-2 pt-1">
                                            Payment Options
                                        </Title>
                                        <Radio.Group onChange={handlePaymentChange} value={paymentMethod} className="vertical-radio-group" style={{ display: "flex", flexDirection: "row" }}>
                                            <Radio.Button value={'online'} style={{ margin: "5px" }}><Typography level={4}>Pay Online</Typography></Radio.Button>
                                            <Radio.Button value={'inPerson'} style={{ margin: "5px" }}><Typography level={4}>Pay in Person</Typography></Radio.Button>
                                        </Radio.Group>
                                    </div>
                                }

                                {(!isOnlinePayment && isInPersonPayment) &&
                                    <div className="p-4">
                                        <Title level={4} tag="h3" className="fw-bold mb-3 mt-2 pt-1">
                                            Payment Options
                                        </Title>
                                        <Typography>This location only accepts payment in person. Please be sure to have enough cash or your card ready.</Typography>
                                    </div>
                                }

                                <div className="p-4">
                                    <Title level={4} tag="h3" className="fw-bold mb-3 mt-2 pt-1">
                                        Customer Information
                                    </Title>
                                    <CustomerInfoForm />
                                </div>
                            </Col>
                            <Col xs={24} md={12}>
                                <div
                                    className="p-4 OrderSummaryDiv"
                                    style={{
                                        maxHeight: isExpanded ? "none" : "275px", // Expand fully or set max height
                                        overflowY: isExpanded ? "visible" : "hidden", // Hide overflow when collapsed
                                        transition: "max-height 0.75s ease", // Smooth transition
                                        position: "relative",
                                    }}
                                >
                                    <Title level={4} tag="h3" className="fw-bold mb-3 mt-2 pt-1">
                                        Cart Summary ({cartNum} {cartNum > 1 ? 'items' : 'item'})
                                    </Title>

                                    {cart.map((cartItem, index) => {
                                        const product = products.find(
                                            (p) => p.productCode === cartItem.productCode
                                        );
                                        // console.log(cartItem.productCode);
                                        console.log(product);
                                        return (
                                            <div
                                                key={(cartItem.itemPromoType || "null") + cartItem.productCode}
                                            >
                                                <Row className="d-flex justify-content-between align-items-center">
                                                    <Col style={{ width: "100px" }}>
                                                        <div className="w-100 cart-item-col">
                                                            <img
                                                                width="100px"
                                                                alt={cartItem.productName}
                                                                src={`https://takeoutpictures.blob.core.windows.net/weborderpictures/medium/${encodeURIComponent(product.pictureURL)}`}
                                                                // fluid
                                                                className="rounded-3"
                                                                onError={({ currentTarget }) => {
                                                                    currentTarget.style.display = 'none';
                                                                }}
                                                            //onError={(e) => {
                                                            //    e.target.src = "https://takeoutpictures.blob.core.windows.net/weborderpictures/medium/img-placeholder.png";
                                                            //    e.target.onerror = null;
                                                            //}}
                                                            />
                                                        </div>
                                                    </Col>

                                                    <Col style={{ width: "calc(100% - 100px)", paddingLeft: "10px" }}>
                                                        <Row>
                                                            <Col span={17} className="w-100 cart-item-col">
                                                                <Row>
                                                                    <Typography.Title level={5} className="text-black flex-wrap">
                                                                        {product.productName} {cartItem.singleProductPrice === 0 && <> (Promotional Item)</>}
                                                                    </Typography.Title>
                                                                </Row>
                                                                <Row>
                                                                    {cartItem.singleProductPrice * cartItem.quantity <
                                                                        product.price * cartItem.quantity ? (
                                                                        <>
                                                                            <strike>
                                                                                <Typography.Title level={5} className="mb-0">
                                                                                    ${(product.price * cartItem.quantity).toFixed(2)}
                                                                                </Typography.Title>
                                                                            </strike>

                                                                            <Typography.Title level={5} className="mb-0">
                                                                                $
                                                                                {(
                                                                                    cartItem.singleProductPrice * cartItem.quantity
                                                                                ).toFixed(2)}
                                                                            </Typography.Title>
                                                                        </>
                                                                    ) : (
                                                                        <Typography.Title level={5} className="mb-0">
                                                                            $
                                                                            {(
                                                                                cartItem.singleProductPrice * cartItem.quantity
                                                                            ).toFixed(2)}
                                                                        </Typography.Title>
                                                                    )}
                                                                </Row>

                                                            </Col>

                                                            <Col span={7} className="w-100 cart-item-col">
                                                                <Typography.Title
                                                                    level={5}
                                                                    className="align-items-center"
                                                                    style={{ paddingLeft: "10px", paddingRight: "5px", margin: "0", minWidth: "26px", justifyContent: "flex-end", display: "flex" }}
                                                                >
                                                                    Qty: {cartItem.quantity}
                                                                </Typography.Title>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>

                                                <hr className="my-4" />
                                            </div>
                                        );
                                    })}
                                </div>

                                <div style={{ textAlign: "center", marginTop: "10px" }}>
                                    <button
                                        onClick={toggleExpand}
                                        style={{
                                            backgroundColor: "transparent",
                                            border: "none",
                                            cursor: "pointer",
                                            textDecoration: "underline",
                                            padding: "10px",
                                            color: "#f17fb2",
                                            fontSize: "18px",
                                            fontWeight: "500"
                                        }}
                                    >
                                        {isExpanded ? "Show Less" : "Show All"}
                                    </button>
                                </div>

                                <div className="p-4 OrderSummaryDiv">
                                    <Title level={4} tag="h3" className="fw-bold mb-3 mt-2 pt-1">
                                        Summary
                                    </Title>

                                    <hr className="my-4" />

                                    {/*<div className="d-flex justify-content-between mb-4">*/}
                                    {/*    <Typography tag="h5" className="text-uppercase">*/}
                                    {/*        items x {cart.length}*/}
                                    {/*    </Typography>*/}
                                    {/*    <Typography tag="h5">$ {cart[0].subtotal}</Typography>*/}
                                    {/*</div>*/}

                                    <div className="d-flex justify-content-between mb-4">
                                        <Typography tag="h5" className="text-uppercase">
                                            Subtotal
                                        </Typography>
                                        <Typography tag="h5">${cart[0].orderSubtotal.toFixed(2)}</Typography>
                                    </div>

                                    {/*<div className="d-flex justify-content-between mb-4">*/}
                                    {/*    <Typography tag="h5" className="text-uppercase">*/}
                                    {/*        Product Discount*/}
                                    {/*    </Typography>*/}
                                    {/*    <Typography tag="h5">-${*/}
                                    {/*        (cart.reduce((accumulator, currentCart) => {*/}
                                    {/*            return accumulator + (currentCart.productDiscount * currentCart.quantity);*/}
                                    {/*        }, 0)).toFixed(2)*/}
                                    {/*    }</Typography>*/}
                                    {/*</div>*/}

                                    {deliveryOrPickUp === "delivery" && (
                                        <div className="d-flex justify-content-between mb-4">
                                            <Typography tag="h5" className="text-uppercase">
                                                Delivery
                                            </Typography>
                                            {/*{cart[0].deliverFee === 0 ? (*/}
                                            {/*    <Typography tag="h5">FREE!</Typography>*/}
                                            {/*) : (*/}
                                            {/*    <Typography tag="h5">${cart[0].deliveryFee.toFixed(2)}</Typography>*/}
                                            {/*)}*/}
                                            <Typography tag="h5">${cart[0].originalDeliveryFee.toFixed(2)}</Typography>
                                        </div>
                                    )}

                                    {(deliveryOrPickUp === "delivery" && (cart[0].originalDeliveryFee - cart[0].deliveryFee > 0)) && (
                                        <div className="d-flex justify-content-between mb-4">
                                            <Typography tag="h5" className="text-uppercase">
                                                Delivery Discount
                                            </Typography>
                                            {/*{cart[0].deliverFee === 0 ? (*/}
                                            {/*    <Typography tag="h5">FREE!</Typography>*/}
                                            {/*) : (*/}
                                            {/*    <Typography tag="h5">${cart[0].deliveryFee.toFixed(2)}</Typography>*/}
                                            {/*)}*/}
                                            <Typography tag="h5">(${(cart[0].originalDeliveryFee - cart[0].deliveryFee).toFixed(2)})</Typography>
                                        </div>
                                    )}

                                    {(cart[0].orderTotalDiscount - (cart[0].originalDeliveryFee - cart[0].deliveryFee) > 0) && (
                                        <div className="d-flex justify-content-between mb-4">
                                            <Typography tag="h5" className="text-uppercase">
                                                Order Discount
                                            </Typography>
                                            <Typography tag="h5">(${
                                                (cart[0].orderTotalDiscount - (cart[0].originalDeliveryFee - cart[0].deliveryFee)).toFixed(2)
                                            })</Typography>
                                        </div>
                                    )}

                                    <div className="d-flex justify-content-between mb-4">
                                        <Typography tag="h5" className="text-uppercase">
                                            Estimated Tax
                                        </Typography>
                                        <Typography tag="h5">${cart[0].orderTax.toFixed(2)}</Typography>
                                    </div>

                                    <hr className="my-4" />

                                    <div className="d-flex justify-content-between mb-5">
                                        <Typography tag="h5" className="text-uppercase">
                                            Total price
                                        </Typography>
                                        <Typography tag="h5">$ {cart[0].totalPrice.toFixed(2)}</Typography>
                                    </div>

                                    {!submitDisabled && (
                                        <Button
                                            className="Checkout-btn btn-primary"
                                            shape="round"
                                            onClick={() => { validateForm(); }}
                                        >
                                            Place {deliveryOrPickUp === "delivery" ? "Delivery Order" : "Pickup Order"}
                                        </Button>
                                        //<>
                                        //    {paymentMethod === "online" ?
                                        //        //<Button
                                        //        //    color="dark"
                                        //        //    block
                                        //        //    size="lg"
                                        //        //    className="placeorder_btn btn-primary"
                                        //        //    onClick={() => {
                                        //        //        validateForm();
                                        //        //        //if (isFormValid) {
                                        //        //        //    console.log("form is valid");
                                        //        //        //    submitOrder();
                                        //        //        //}
                                        //        //        //else {
                                        //        //        //    console.log("form is invalid");
                                        //        //        //}
                                        //        //    }}
                                        //        //>
                                        //        //    Payment
                                        //        //</Button>

                                        //        <Button
                                        //            className="upsellCheckout-btn btn-primary"
                                        //            shape="round"
                                        //            onClick={() => {validateForm();}}
                                        //        >
                                        //            Continue
                                        //        </Button>
                                        //        :
                                        //        <Button
                                        //            className="upsellCheckout-btn btn-primary"
                                        //            shape="round"
                                        //            onClick={() => {
                                        //                validateForm();
                                        //                //if (isFormValid) {
                                        //                //    submitOrder();
                                        //                //}
                                        //            }}
                                        //        >
                                        //            Place Order
                                        //        </Button>
                                        //    }
                                        //</>
                                    )}
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
            <StoreNotDeliverableModal
                visible={deliveryAddressModalVisible}
                onCancel={closeModal}
                onChangeToPickup={handleChangeToPickup}
                onChangeStore={handleChangeStore}
                store={deliverableStore}
            />
            <ExtendedDeliveryLowerThan20Modal
                visible={extendedDeliveryModalVisible}
                onCancel={closeModal}
                onChangeToPickup={handleChangeToPickup}
                onBacktoMenu={handleBacktoMenu}
            />
            <TipsModal
                visible={tipsModalVisible}
                onCancel={closeModal}
                onSubmit={onTipSubmit}
            />
        </Container >
    );
}